import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    active: false,
    create: false,
    edit: false,
    delete: false,
};
export const modalSlice = createSlice({
    name: "toggleModal",
    initialState,
    reducers: {
        closeModal: (state) => {
            state.active = false;
        },
        openModal: (state) => {
            state.active = true;
        },

        createModel: (state) => {
            state.create = !state.create;
        },
        editModel: (state) => {
            state.create = !state.create;
        },
        deleteModel: (state) => {
            state.create = !state.create;
        },
    },
});

export const { closeModal, openModal, createModel, editModel, deleteModel } =
    modalSlice.actions;
export default modalSlice.reducer;
